import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getWithdrawals = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/withdrawals/?${params}`);
};

const getWithdrawalInfo = () => API.get('/users/me/withdrawal-info/');

const withdrawByBank = (
  balloon,
  name,
  registrationNumber,
  phoneNumber,
  bank,
  bankAccount,
  dueDate
) =>
  API.post('/store/withdraw-by-bank/', {
    balloon,
    name,
    registrationNumber,
    phoneNumber,
    bank,
    bankAccount,
    dueDate,
  });

export default {
  getWithdrawals,
  getWithdrawalInfo,
  withdrawByBank,
};



// WEBPACK FOOTER //
// ./src/app/apis/withdrawal.js